import { cn } from "@/lib/utils";

interface FranklinIconProps {
  /** Sizing / spacing / color classes — `bg-current` follows the text color. */
  className?: string;
}

const MASK_SRC = "url(/franklin-logo.svg)";

/**
 * FranklinIcon — the Franklin logomark rendered as a monochrome icon
 * (WHA-3458). A CSS mask over the logo SVG lets the mark inherit the current
 * text color (`bg-current`), so it sits next to lucide icons in menus and
 * buttons as one consistent "Add from Franklin" / "Browse Projects" glyph.
 */
export function FranklinIcon({ className }: FranklinIconProps) {
  return (
    <span
      aria-hidden
      className={cn("inline-block h-4 w-4 shrink-0 bg-current", className)}
      style={{
        WebkitMaskImage: MASK_SRC,
        maskImage: MASK_SRC,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}
